import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/features/modalSlice";
import { useUpdateGaonMutation } from "../../redux/services/gaonService/gaon.Services";
import { useGetWaadDropdownQuery } from "../../redux/services/waadService/waad.Services";
import { successToast, errorToast } from "../../Utils/toast";

function EditGaon({ data }) {
    const dispatch = useDispatch();
    const [updateGaon, { isLoading }] = useUpdateGaonMutation();
    const { data: waadData } = useGetWaadDropdownQuery();

    const [formData, setFormData] = useState({
        id: data?.id,
        waad_id: "",
        gaon_name: "",
        population: "",
        pincode: "",
        status: 1, // ✅ Default 1 = Active
    });

    useEffect(() => {
        if (data) {
            setFormData({
                id: data.id,
                waad_id: data.waad_id || "",
                gaon_name: data.gaon_name || "",
                population: data.population || "",
                pincode: data.pincode || "",
                // ✅ Status: 1 = Active, 0 = Inactive
                status: data.status === 1 || data.status === "1" || data.status === true ? 1 : 0,
            });
        }
    }, [data]);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.waad_id) {
            errorToast("Error", "Please select a waad");
            return;
        }

        if (!formData.gaon_name.trim()) {
            errorToast("Error", "Gaon name is required");
            return;
        }

        try {
            const payload = {
                id: formData.id,
                waad_id: parseInt(formData.waad_id),
                gaon_name: formData.gaon_name,
                population: parseInt(formData.population) || 0,
                pincode: formData.pincode,
                status: parseInt(formData.status), // ✅ 1 or 0
            };

            await updateGaon(payload).unwrap();
            successToast("Success", "Gaon updated successfully");
            dispatch(closeModal());
            window.location.reload();
        } catch (error) {
            console.error("Update error:", error);
            errorToast("Error", error?.data?.message || "Failed to update gaon");
        }
    };

    return (
        <div className="custom-modal-body">
            <form onSubmit={handleSubmit}>
                <div className="edit-form-group">
                    <label className="fw-semibold">
                        Select Waad <span className="text-danger">*</span>
                    </label>
                    <select
                        name="waad_id"
                        value={formData.waad_id}
                        onChange={handleChange}
                        className="form-control"
                        required
                    >
                        <option value="">Select Waad</option>
                        {waadData?.data?.map((waad) => (
                            <option key={waad.id} value={waad.id}>
                                {waad.waad_name}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="edit-form-group mt-3">
                    <label className="fw-semibold">
                        Gaon Name <span className="text-danger">*</span>
                    </label>
                    <input
                        type="text"
                        name="gaon_name"
                        value={formData.gaon_name}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Enter Gaon Name"
                        required
                        autoFocus
                    />
                </div>

                <div className="edit-form-group mt-3">
                    <label className="fw-semibold">Population</label>
                    <input
                        type="number"
                        name="population"
                        value={formData.population}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Enter Population"
                        min="0"
                    />
                </div>

                <div className="edit-form-group mt-3">
                    <label className="fw-semibold">Pincode</label>
                    <input
                        type="text"
                        name="pincode"
                        value={formData.pincode}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Enter Pincode"
                        maxLength="10"
                    />
                </div>

                {/* ✅ Status - 1 = Active, 0 = Inactive */}
                <div className="edit-form-group mt-3">
                    <label className="fw-semibold">Status</label>
                    <select
                        name="status"
                        value={formData.status}
                        onChange={handleChange}
                        className="form-control"
                    >
                        <option value={1}>Active</option>
                        <option value={0}>Inactive</option>
                    </select>
                </div>

                {/* BUTTONS */}
                <div className="modal-btn-group mt-4">
                    <button
                        type="button"
                        className="cancel-btn"
                        onClick={() => dispatch(closeModal())}
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="save-btn"
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" />
                                Saving...
                            </>
                        ) : (
                            "Save Changes"
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
}

export default EditGaon;